<template>
  <nav :class="{
         [`bx-${menuType}__navi`]: true,
         [`bx-typo--${menuContext}-navi`]: true
       }"
       aria-label="Hauptnavigation"
       @mouseleave="handleMouseLeave">
    <div :class="{
      [`bx-${menuType}__navi-list`]: true,
      [`bx-${menuType}__navi-list--level-0`]: true
    }">
      <template v-for="item in menu">
        <MenuItem v-if="menuContext !== 'desktop' || !item.burgerOnly"
                  :key="item.index"
                  :menu-item="item"
                  :opened-menu-item="openedMenuItem"
                  :level="1"
                  :menu-type="menuType"
                  :menu-context="menuContext"
                  :brand="brand"
                  @menu-item-hovered="openedMenuItem = $event" />
      </template>
    </div>
  </nav>
</template>

<script>
import MenuItem from './MenuItem.vue'

export default {
  components: {
    MenuItem
  },
  props: {
    menu: {
      type: Array,
      default: () => {
        return []
      }
    },
    menuType: {
      type: String,
      default: ''
    },
    menuContext: {
      type: String,
      default: 'footer',
      validator: function (value) {
        return ['burger', 'desktop', 'footer'].includes(value)
      }
    },
    brand: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      openedMenuItem: null
    }
  },
  mounted () {
    document.documentElement.classList.add('bx-js-loaded')
  },
  methods: {
    handleMouseLeave () {
      if (this.menuContext !== 'desktop') return
      this.openedMenuItem = null
    }
  }
}
</script>
